import { t } from '@/i18n';
import StatusMessage from '@/registrations/StatusMessage';
import type { RegistrationResponse } from '../types';

interface RegistrationConfirmationProps {
  registration: RegistrationResponse;
  price?: string | null;
  currency?: string;
}

export default function RegistrationConfirmation({ registration, price, currency }: RegistrationConfirmationProps) {
  const manageUrl = `/event-signup/${registration.manage_token}/`;

  return (
    <div className="space-y-4 text-center">
      <StatusMessage
        status={registration.status}
        payment_status={registration.payment_status}
        price={price ?? null}
        currency={currency ?? ''}
        waitlist_position={registration.waitlist_position}
      />

      {/* Echo the entered email so the user can catch their own typo while the
          on-screen manage link — their only credential if the email is wrong —
          is still visible. */}
      <div className="text-sm text-gray-500 dark:text-gray-400">
        <p>
          {t('Confirmation sent to')}{' '}
          <span className="font-semibold text-gray-700 dark:text-gray-200">{registration.email}</span>
        </p>
        <p className="mt-1 text-xs text-amber-600 dark:text-amber-500">
          {t('Typo in your email? Update it from your registration page below.')}
        </p>
      </div>

      <div className="rounded-lg border border-gray-200 bg-gray-50 p-4 dark:border-gray-700 dark:bg-gray-900">
        <p className="text-xs font-medium text-gray-500 dark:text-gray-400">
          {t('Manage your registration')}
        </p>
        <a
          href={manageUrl}
          className="mt-1 block text-sm font-medium text-teal-600 hover:text-teal-500 dark:text-teal-400"
        >
          {window.location.origin}{manageUrl}
        </a>
        <p className="mt-2 text-xs text-gray-400 dark:text-gray-500">
          {t('Save this link to view or manage your registration.')}
        </p>
      </div>
    </div>
  );
}
